import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import ForgotPassword from "../../components/forms/ForgotPassword";

class PasswordReset extends Component {
  state = {
    loader: true
  };

  render() {
    return (
      <React.Fragment>
        <Helmet title="ForgotPassword" />
        <div className="background">
          <div className="container">
            <div className="row">
              <div className="col-12 no-gutter-col">
                <div className="signInUpFlow">
                  <ForgotPassword />
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

export default {
  component: connect(mapStateToProps)(PasswordReset)
};
